import { render, staticRenderFns } from "./shengjiNew.vue?vue&type=template&id=64625218&scoped=true"
import script from "./shengjiNew.vue?vue&type=script&lang=js"
export * from "./shengjiNew.vue?vue&type=script&lang=js"
import style0 from "./shengjiNew.vue?vue&type=style&index=0&id=64625218&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64625218",
  null
  
)

export default component.exports